import { NgModule } from '@angular/core';
import { Routes, RouterModule, GuardsCheckStart, GuardsCheckEnd } from '@angular/router';
import { MainComponent } from './content/pages/main/main.component';
import { WebAgoraWebButtonComponent } from './content/pages/conexion/web-agoraweb-button/web-agoraweb-button.component';
import { WebCardsButtonComponent } from './content/pages/conexion/web-cards-button/web-cards-button.component';
import { ApiOperationsComponent } from './content/pages/api/api-operations/api-operations.component';
import { ApiEventsComponent } from './content/pages/api/api-events/api-events.component';
import { ApiOrdersComponent } from './content/pages/api/api-orders/api-orders.component';
import { FlutterCardsButtonComponent } from './content/pages/conexion/flutter-cards-button/flutter-cards-button.component';
import { FlutterAgorawebButtonComponent } from './content/pages/conexion/flutter-agoraweb-button/flutter-agoraweb-button.component';

const routes: Routes = [
  { path: '', component: MainComponent },
  { path: 'main', component: MainComponent },
  { path: 'web-agoraweb-button', component: WebAgoraWebButtonComponent },
  { path: 'web-cards-button', component: WebCardsButtonComponent },
  { path: 'flutter-agoraweb-button', component: FlutterAgorawebButtonComponent },
  { path: 'flutter-cards-button', component: FlutterCardsButtonComponent },
  { path: 'api-orders', component: ApiOrdersComponent },
  { path: 'api-operations', component: ApiOperationsComponent },
  { path: 'api-events', component: ApiEventsComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
